import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../constant.js";
import Theme from "../Theme.js";

const Forgotpassword = () => {
  const navigate = useNavigate();

  const [oldpassword, setoldpassword] = useState("");
  const [newpassword, setnewpassword] = useState("");
  const [confurmpassword, setconfurmpassword] = useState("");
  const [message, setmessage] = useState("");
  const [alert, setalert] = useState("");
  const [change, setchangepassword] = useState("");
  const [isfirsttimelogin, setisfirsttimelogin] = useState("");

  const getTheme = () => {
    const stored = localStorage.getItem("background") || "light";
    const legacy = { 0: "dark", 1: "light", 2: "green" };
    const key = legacy[stored] || stored;
    if (key === "dark") {
      return {
        pageBg: "#1e293b",
        cardBg: "rgba(15, 23, 42, 0.55)",
        inputBg: "#334155",
        border: "#475569",
        text: "#ffffff",
        muted: "#94a3b8",
        accent: "#b28e4d",
        btnBg: "linear-gradient(45deg, #064a3c, #1b715f)",
        btnText: "#ffffff",
      };
    }
    if (key === "green") {
      return {
        pageBg: "#1e5655",
        cardBg: "rgba(6, 74, 60, 0.45)",
        inputBg: "#164544",
        border: "#36474f",
        text: "#ffffff",
        muted: "#efda95",
        accent: "#b28e4d",
        btnBg: "linear-gradient(45deg, #b29046, #d3b86a)",
        btnText: "#4b3b18",
      };
    }
    return {
      pageBg: "#edf9fe",
      cardBg: "rgba(255, 255, 255, 0.85)",
      inputBg: "#ffffff",
      border: "#c5d9e6",
      text: "#064a3c",
      muted: "#5a7a88",
      accent: "#1b715f",
      btnBg: "linear-gradient(45deg, #064a3c, #1b715f)",
      btnText: "#ffffff",
    };
  };

  const theme = getTheme();

  useEffect(() => {
    const firsttimelogin = localStorage.getItem("firsttimelogin");
    if (firsttimelogin == 1) {
      setchangepassword("1");
    }
  }, []);

  const firstlogin = async () => {
    if (change == 1) {
      setisfirsttimelogin("Please change the password for first time login");
    } else {
      navigate("/seeting");
    }
  };

  const updatepassword = async () => {
    setmessage("");
    setalert("");
    if (newpassword === confurmpassword) {
      setmessage("");
      const token = localStorage.getItem("token");
      const formdata = new FormData();
      formdata.append("Token", token);
      formdata.append("opw", oldpassword);
      formdata.append("npw", newpassword);
      const result = await axios.post(
        baseUrl + `authController/changePassword`,
        formdata,
      );

      setmessage(result.data.message);
      if (result.data.status == 1) {
        localStorage.removeItem("Name");
        localStorage.removeItem("userCode");
        localStorage.removeItem("token");
        navigate("/login");
      }
    } else {
      setalert("Password and confirm password do not match");
    }
  };

  const inputWrapStyle = {
    border: `1px solid ${theme.border}`,
    borderRadius: 12,
    margin: "16px 0",
    padding: "4px 14px",
    background: theme.inputBg,
  };

  const inputStyle = {
    background: "transparent",
    border: 0,
    color: theme.text,
    fontWeight: 600,
    padding: "10px 0 10px 28px",
    width: "100%",
    outline: "none",
    boxShadow: "none",
  };

  return (
    <>
      <Theme />
      <section className="online_trade_view">
        <div className="text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div
                  className="screen_login_form screen_body __login_form_card"
                  style={{ background: theme.pageBg }}
                >
                  <div
                    className="login_form loginformdark"
                    style={{
                      background: theme.cardBg,
                      borderRadius: 16,
                      padding: "12px 16px 24px",
                    }}
                  >
                    <div
                      className="dashboard_header"
                      style={{
                        marginTop: 0,
                        justifyContent: "space-between",
                        padding: "8px 0 12px",
                      }}
                    >
                      <div
                        onClick={firstlogin}
                        style={{
                          cursor: "pointer",
                          color: theme.text,
                          fontSize: 22,
                          lineHeight: 1,
                          width: 32,
                        }}
                      >
                        <i
                          className="fa fa-angle-left"
                          style={{ color: "white" }}
                        ></i>
                      </div>
                      <h4
                        className="homesignin"
                        style={{
                          margin: 0,
                          fontSize: 17,
                          fontWeight: 700,
                          color: theme.text,
                        }}
                      >
                        Change Password
                      </h4>
                      <div style={{ width: 32 }} />
                    </div>

                    <div className="logo_f text-center">
                      <Link
                        to="#"
                        className="logo"
                        onClick={(e) => {
                          e.preventDefault();
                          firstlogin();
                        }}
                      >
                        <img
                          src="assets/img/logo1.png"
                          className="img-fluid"
                          alt="logo"
                        />
                      </Link>
                    </div>

                    <div className="loginpageformdiv" style={{ marginTop: 12 }}>
                      <form className="login_form_section Forgot_form">
                        <h4
                          className="homesignin"
                          style={{
                            textAlign: "left",
                            color: theme.text,
                            marginBottom: 4,
                          }}
                        >
                          Update Password
                        </h4>
                        <p
                          style={{
                            textAlign: "left",
                            color: theme.muted,
                            fontSize: 13,
                            marginBottom: 8,
                          }}
                        >
                          Enter your existing password and set a new one.
                        </p>

                        <div
                          className="form-group form_fill_group"
                          style={inputWrapStyle}
                        >
                          <div
                            className="form_icons"
                            style={{ position: "relative" }}
                          >
                            <i
                              className="fa fa-lock"
                              style={{
                                position: "absolute",
                                left: 0,
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: theme.accent,
                              }}
                            ></i>
                            <input
                              type="password"
                              name="oldpassword"
                              className="form-control"
                              placeholder="Existing Password"
                              value={oldpassword}
                              onChange={(e) => setoldpassword(e.target.value)}
                              style={inputStyle}
                            />
                          </div>
                        </div>

                        <div
                          className="form-group form_fill_group"
                          style={inputWrapStyle}
                        >
                          <div
                            className="form_icons"
                            style={{ position: "relative" }}
                          >
                            <i
                              className="fa fa-key"
                              style={{
                                position: "absolute",
                                left: 0,
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: theme.accent,
                              }}
                            ></i>
                            <input
                              type="password"
                              name="newpassword"
                              className="form-control"
                              placeholder="New Password"
                              value={newpassword}
                              onChange={(e) => setnewpassword(e.target.value)}
                              style={inputStyle}
                            />
                          </div>
                        </div>

                        <div
                          className="form-group form_fill_group"
                          style={inputWrapStyle}
                        >
                          <div
                            className="form_icons"
                            style={{ position: "relative" }}
                          >
                            <i
                              className="fa fa-check-circle"
                              style={{
                                position: "absolute",
                                left: 0,
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: theme.accent,
                              }}
                            ></i>
                            <input
                              type="password"
                              name="confirmpassword"
                              className="form-control"
                              placeholder="Confirm Password"
                              value={confurmpassword}
                              onChange={(e) =>
                                setconfurmpassword(e.target.value)
                              }
                              style={inputStyle}
                            />
                          </div>
                        </div>

                        {alert ? (
                          <h6
                            style={{
                              color: "#ff6b6b",
                              textAlign: "left",
                              fontSize: 13,
                              marginTop: 4,
                            }}
                          >
                            {alert}
                          </h6>
                        ) : null}

                        {message ? (
                          <h6
                            style={{
                              color: theme.accent,
                              textAlign: "left",
                              fontSize: 13,
                              marginTop: 4,
                            }}
                          >
                            {message}
                          </h6>
                        ) : null}

                        {isfirsttimelogin ? (
                          <h6
                            style={{
                              color: theme.muted,
                              textAlign: "left",
                              fontSize: 13,
                              marginTop: 4,
                            }}
                          >
                            {isfirsttimelogin}
                          </h6>
                        ) : null}

                        <div className="form-group" style={{ marginTop: 18 }}>
                          <button
                            type="button"
                            className="btn btn-login"
                            onClick={updatepassword}
                            style={{
                              background: theme.btnBg,
                              color: theme.btnText,
                              border: "none",
                              borderRadius: 12,
                              width: "100%",
                              fontWeight: 700,
                              padding: "10px 12px",
                            }}
                          >
                            Update Password
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Forgotpassword;
